var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "component-loader" } }, [
      _c("div", { staticClass: "spinner" }, [
        _c("div", { staticClass: "dot1" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }